import React from 'react'
import { Link,useNavigate } from 'react-router-dom'
import {BsEye,BsEyeSlash} from 'react-icons/bs'
import { FiUser, FiAtSign, FiMail, FiGlobe, FiPhone, FiLock } from 'react-icons/fi'
import { useState,useEffect } from 'react'
import Swal from 'sweetalert2'
import Loader from '../components/Loader'
import AuthLayout from '../components/authLayout/AuthLayout'

const Signup = ({route}) => {
  const navigate = useNavigate()
  const [showPassword, setShowPassword] =  useState(false)
  const [showConfirmPassword, setShowConfirmPassword] =  useState(false)
  const [firstname,setFirstname] = useState('')
  const [username,setUserName] = useState('')
  const [lastname,setLastname] = useState('')
  const [email,setEmail] = useState('')
  const [phoneNumber,setPhoneNumber] = useState('')
  const [password,setPassword] = useState('')
  const [confirmPassword,setConfirmPassword] = useState('')
  const [loader, setLoader] = useState(false)

const [location, setLocation] = useState({ lat: null, lng: null });
const [country, setCountry] = useState('');
const [deviceName, setDeviceName] = useState('');

useEffect(() => {
  // Get user's geolocation
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        setLocation({ lat: latitude, lng: longitude });

        try {
          // Fetch country name using reverse geocoding from Nominatim
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
          );
          const data = await res.json();
          if (data?.address?.country) {
            // only prefill, never overwrite what the user typed
            setCountry(prev => prev || data.address.country);
          }
        } catch (err) {
          console.warn('Could not fetch country from coordinates:', err);
        }
      },
      (error) => {
        console.warn('Geolocation not available or denied:', error);
      }
    );
  }

  // Detect OS and browser from userAgent
  const ua = navigator.userAgent;
  let os = 'Unknown OS';
  let browser = 'Unknown Browser';

  if (/windows/i.test(ua)) os = 'Windows';
  else if (/mac/i.test(ua)) os = 'MacOS';
  else if (/android/i.test(ua)) os = 'Android';
  else if (/linux/i.test(ua)) os = 'Linux';
  else if (/iphone|ipad/i.test(ua)) os = 'iOS';

  if (/chrome/i.test(ua) && !/edge|opr/i.test(ua)) browser = 'Chrome';
  else if (/firefox/i.test(ua)) browser = 'Firefox';
  else if (/safari/i.test(ua) && !/chrome/i.test(ua)) browser = 'Safari';
  else if (/edge/i.test(ua)) browser = 'Edge';
  else if (/opr|opera/i.test(ua)) browser = 'Opera';

  setDeviceName(`${os} – ${browser}`);
}, []);


  
  
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

  // Signup function
  const Signup = async () => {
  setLoader(true);

  try {
    const referringUser = localStorage.getItem('referedUser') || '';
    const response = await fetch(`${route}/api/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        firstName: firstname,
        lastName: lastname,
        userName: username,
        password: password,
        email: email,
        phonenumber: phoneNumber,
        referralLink: referringUser,
        server: activeServer,
        location,
        deviceName,
        country
      }),
    });

    const result = await response.json();
    setLoader(false);
    

    if (result.status === 'error') {
      Toast.fire({
        icon: 'warning',
        title: `${result.message}`,
      });
      return;
    }

    // Save token and navigate to dashboard
    localStorage.setItem('token', result.token);

    // welcome, admin and referral emails are sent by the backend during registration
        Toast.fire({
        icon: 'success',
        title: 'Account successfully created!'
        })

    // Clear form and localStorage
    setFirstname('');
    setLastname('');
    setUserName('');
    setEmail('');
    setPhoneNumber('');
    setPassword('');
    setConfirmPassword('');
    
    localStorage.removeItem('referedUser');

    navigate('/onboarding');
  } catch (error) {
    setLoader(false);
    console.error("Error during signup:", error);
    Toast.fire({
      icon: 'error',
      title: 'Something went wrong. Please try again.',
    });
  }
};

  const [activeServer, setActiveServer] = useState(null); // stores 'server1', 'server2', 'server3'

  const handleCheckboxChange = (serverId) => {
    setActiveServer(prev => (prev === serverId ? null : serverId)); // toggle if same clicked again
  };

  const passwordsMatch = () => {
    if (password !== confirmPassword) {
      Toast.fire({
        icon: 'warning',
        title: "Passwords don't match",
      });
      return false;
    }
    return true;
  }

  return (
    <AuthLayout
      heading="Create your account"
      subheading="Start growing your capital with expert-managed copy trading."
    >
      {loader && <Loader />}
      <form className="auth-form" onSubmit={(e) => {
        e.preventDefault()
        if (passwordsMatch()) Signup()
      }}>
        <div className="auth-row">
          <div className="auth-field">
            <label htmlFor="firstname_field">First name</label>
            <div className="auth-input-wrap">
              <span className="auth-input-icon"><FiUser size={17} /></span>
              <input id="firstname_field" className="auth-input" type="text" autoComplete="given-name"
                placeholder="John" required value={firstname}
                onChange={(e) => setFirstname(e.target.value.trim())} />
            </div>
          </div>
          <div className="auth-field">
            <label htmlFor="lastname_field">Last name</label>
            <div className="auth-input-wrap">
              <span className="auth-input-icon"><FiUser size={17} /></span>
              <input id="lastname_field" className="auth-input" type="text" autoComplete="family-name"
                placeholder="Doe" required value={lastname}
                onChange={(e) => setLastname(e.target.value.trim())} />
            </div>
          </div>
        </div>

        <div className="auth-field">
          <label htmlFor="username_field">Username</label>
          <div className="auth-input-wrap">
            <span className="auth-input-icon"><FiAtSign size={17} /></span>
            <input id="username_field" className="auth-input" type="text" autoComplete="username"
              placeholder="johnsmith" required value={username}
              onChange={(e) => setUserName(e.target.value.trim())} />
          </div>
        </div>

        <div className="auth-field">
          <label htmlFor="email_field">Email</label>
          <div className="auth-input-wrap">
            <span className="auth-input-icon"><FiMail size={17} /></span>
            <input id="email_field" className="auth-input" type="email" autoComplete="email"
              placeholder="name@mail.com" required value={email}
              onChange={(e) => setEmail(e.target.value.trim().toLocaleLowerCase())} />
          </div>
        </div>

        <div className="auth-row">
          <div className="auth-field">
            <label htmlFor="country_field">Country</label>
            <div className="auth-input-wrap">
              <span className="auth-input-icon"><FiGlobe size={17} /></span>
              <input id="country_field" className="auth-input" type="text" autoComplete="country-name"
                placeholder="United Kingdom" required value={country}
                onChange={(e) => setCountry(e.target.value)} />
            </div>
          </div>
          <div className="auth-field">
            <label htmlFor="phone_field">Mobile</label>
            <div className="auth-input-wrap">
              <span className="auth-input-icon"><FiPhone size={17} /></span>
              <input id="phone_field" className="auth-input" type="tel" autoComplete="tel"
                placeholder="+44 7700 900000" required value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value.trim())} />
            </div>
          </div>
        </div>

        <div className="auth-field">
          <label htmlFor="password_field">Password</label>
          <div className="auth-input-wrap">
            <span className="auth-input-icon"><FiLock size={17} /></span>
            <input id="password_field" className="auth-input has-toggle" type={showPassword ? 'text' : 'password'}
              autoComplete="new-password" placeholder="Create a password" required value={password}
              onChange={(e) => setPassword(e.target.value.trim())} />
            <button type="button" className="auth-eye" onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? 'Hide password' : 'Show password'}>
              {showPassword ? <BsEye size={17} /> : <BsEyeSlash size={17} />}
            </button>
          </div>
        </div>

        <div className="auth-field">
          <label htmlFor="confirm_password_field">Confirm password</label>
          <div className="auth-input-wrap">
            <span className="auth-input-icon"><FiLock size={17} /></span>
            <input id="confirm_password_field" className="auth-input has-toggle" type={showConfirmPassword ? 'text' : 'password'}
              autoComplete="new-password" placeholder="Repeat your password" required value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value.trim())} />
            <button type="button" className="auth-eye" onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}>
              {showConfirmPassword ? <BsEye size={17} /> : <BsEyeSlash size={17} />}
            </button>
          </div>
        </div>

        <button type="submit" className="auth-submit">Create account</button>

        <p className="auth-switch">
          Already have an account? <Link to="/login" className="auth-link">Sign in</Link>
        </p>
        <p className="auth-legal">
          By creating an account you agree to our <Link to="/privacy-policy">Terms &amp; Privacy Policy</Link>.
        </p>
      </form>
    </AuthLayout>
  )
}

export default Signup
